import React from 'react';
import { ListColumnType, QueryParamType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import { useSettings } from 'services/settings/SettingsContext';
import { formatEmailListDate } from 'services/utils/dateTimeUtils';
import { renderTicketStatusBadge } from './TicketStatusBadge';
import TicketForm from './TicketForm';
import TicketConversationModal from './TicketConversationModal';

interface TicketDetailListProps {
    itemId: string;
    detailPage: string;
    data?: any;
}

// The list params per parent detail page
const ticketDetailListConfigurations: Record<string, { params: (itemId: string) => QueryParamType }> = {
    contact: { params: (itemId: string) => ({ reporter: itemId }) },
    person: { params: (itemId: string) => ({ reporter: itemId }) },
    organization: { params: (itemId: string) => ({ organization: itemId }) },
};

// The tickets of a person or organization shown as tab on its detail page
const TicketDetailList: React.FC<TicketDetailListProps> = ({ itemId, detailPage }) => {
    const { userLocale, userTimezone } = useSettings();

    // Get the params of the parent page, fallback to the reporter filter
    const configuration = ticketDetailListConfigurations[detailPage] || ticketDetailListConfigurations.contact;
    const defaultParams = { ...configuration.params(itemId), deleted: false };

    // Specify the columns of this list
    const columns: ListColumnType[] = [
        {
            width: '1.5fr',
            field: 'number',
            label: 'ticket.general.number_label'
        },
        {
            width: '6fr',
            field: 'subject',
            label: 'ticket.general.subject_label'
        },
        {
            width: '2.5fr',
            field: 'last_message_at',
            label: 'ticket.general.last_message_label',
            render: (_, row) => <>{row.last_message_at ? formatEmailListDate(row.last_message_at, userLocale, userTimezone) : ''}</>
        },
        {
            width: '144px',
            field: 'status',
            label: 'ticket.general.status_label',
            render: (_, row) => renderTicketStatusBadge(row.status, row.new_reply)
        }
    ];

    return (
        <div className='detail-list'>
            <AbstractList
                query={{
                    endpoint: 'get_ticket_list',
                    defaultParams,
                    object: 'ticket'
                }}
                objectName='ticket.general.object_name'
                columns={columns}
                showSearch={false}
                buttonSize='small'
                isPaginated={true}
                pageSize={10}
                formModal={<TicketForm linkedItem={{ reporter: parseInt(itemId) }} />}
                modalSize='add-form'
                onRowClick='detailModal'
                detailModal={<TicketConversationModal />}
                detailModalSize='large'
            />
        </div>
    );
};

export default TicketDetailList;
